import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchPackageCategoriesQuery } from '@/features/package-categories'
import { fetchPackageCategoriesList } from '@/features/package-categories/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

import { PackageCategoriesSearchSchema } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/package-categories/'
)({
  validateSearch: (search) => parse(PackageCategoriesSearchSchema, search),
  loaderDeps: ({ search }) => ({ search }),
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId,
          enable: true
        }
      })
    }

    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps: { search },
    context: { auth }
  }) => {
    const query = buildFetchPackageCategoriesQuery(tenantKey, search)

    return {
      authUser: auth.user,
      packageCategories: await fetchPackageCategoriesList(
        query,
        abortController.signal
      )
    }
  }
})
